import { createPopper } from '@popperjs/core';

const timelineItems = document.querySelectorAll('.s-timeline__item');

timelineItems.forEach((item) => {
    // console.log('foreach item');
    // Find tooltip within item
    let tooltip = item.querySelector('.tooltip');

    // Find number within item (the trigger)
    let number = item.querySelector('.number');

    // Create Popper instance
    let popperInstance = createPopper(number, tooltip, {
        placement: 'top',
    });    

    function show() {
        // Make the tooltip visible
        tooltip.setAttribute('data-show', '');    
        popperInstance.update();    
    }
    
    function hide() {    
        tooltip.removeAttribute('data-show');    
    }

    number.addEventListener('mouseenter', show);
    number.addEventListener('mouseleave', hide);
});



// WEBPACK FOOTER //
// ./scripts/routes/sections/timeline.js